export default "dist/20fd1704ea223900efa9fd4e869efb08.woff2";